import "typesafe-actions";
import { RealtimeUpdatesMode, RealtimeMessageTrigger } from "../../redux-folder/realtime/types.js";
import "normalizr";
import "rxjs";
import "rxjs/operators";
import "../../api/types.js";
import "immer";
import { isStringNullOrEmpty } from "../../utils/string.js";
import "moment-timezone";
import "react-intl";
import "@apollo/client/errors";
import "@apollo/client";
import "graphql";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import "react";
import "react-error-boundary";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import "redux-observable";
import "../../redux-folder/async-action/action.js";
import "../../redux-folder/error-handling/action.js";
import "../../redux-folder/actions.js";
import "fast-deep-equal/es6";
import "redux";
import "../../redux-folder/entity/epics.js";
import "../../redux-folder/entity/EntityProvider.js";
import "reselect";
import { useViewInit } from "../../redux-folder/view/hooks.js";
import "../../redux-folder/realtime/RealtimeNotification.js";
function usePlayerReferralData(view, title, uid, filterKey, realtimesMode, getRevenueShareUid, playerReferralEntity) {
  const fields = [
    "referrer_id",
    "invite_code",
    "referee.uid",
    "revenue_share",
    "revenue_generated_total",
    "revenue_share_offering_status",
    "expiration_date.seconds"
  ];
  const { items, totalCount, searchFilter, handlePageChange, handlePageSizeChange, handleSortChange } = useViewInit({
    viewType: view,
    displayName: title,
    entity: {
      entity: playerReferralEntity,
      fields
    },
    defaultFilters: [{ key: filterKey, value: uid }],
    realtime: {
      entity: playerReferralEntity,
      mode: realtimesMode,
      triggers: [{ type: RealtimeMessageTrigger.Add }, { type: RealtimeMessageTrigger.Update }, { type: RealtimeMessageTrigger.Delete }]
    },
    validateFilter: (filter) => !isStringNullOrEmpty(filter?.find((f) => f.key === filterKey)?.value)
  });
  const refereeItems = items?.map((i) => ({
    ...i,
    revenue_share_uid: getRevenueShareUid(i)
  }));
  return {
    items: refereeItems,
    rawItems: items?.map((i) => ({ isValid: true, raw: JSON.stringify(i) })),
    totalCount,
    searchFilter,
    handlePageChange,
    handlePageSizeChange,
    handleSortChange
  };
}
function useRefereeRevenueInfoData(view, title, uid, playerReferralEntity) {
  return usePlayerReferralData(
    view,
    title,
    uid,
    "referrer_id",
    RealtimeUpdatesMode.Confirm,
    (i) => i?.referee?.uid,
    playerReferralEntity
  );
}
function useReferralInfoData(view, title, uid, playerReferralEntity, userProfileEntity) {
  const { items, rawItems } = usePlayerReferralData(
    view,
    title,
    uid,
    "referee_uid",
    RealtimeUpdatesMode.Silent,
    () => uid,
    playerReferralEntity
  );
  const referral = items?.[0];
  const { items: userItems } = useViewInit({
    viewType: view,
    displayName: title,
    entity: {
      entity: userProfileEntity,
      fields: ["uid", "affiliate.btag"]
    },
    defaultFilters: [{ key: "uid", value: uid }],
    realtime: {
      entity: userProfileEntity,
      mode: RealtimeUpdatesMode.Silent,
      triggers: uid ? [
        {
          type: RealtimeMessageTrigger.Update,
          args: {
            filter: {
              field: "uid",
              value: uid
            }
          }
        }
      ] : void 0
    },
    validateFilter: (filter) => !isStringNullOrEmpty(filter?.find((f) => f.key === "uid")?.value)
  });
  const affiliate = userItems?.[0]?.affiliate;
  return { referral, rawReferral: rawItems?.[0], affiliate };
}
export {
  usePlayerReferralData,
  useRefereeRevenueInfoData,
  useReferralInfoData
};
//# sourceMappingURL=hooks.js.map
